import { z } from 'zod'
import { oc } from '@orpc/contract'

// Super Admin's manual assignment of an Unmatched Patient (PD-1928). Both procedures refuse a
// patient without an open unmatched-patient Task.

export const listUnmatchedPatientOrganizations = oc
  .route({ method: 'GET', path: '/v2/super/patients/{patientId}/eligible-organizations' })
  .input(z.object({ patientId: z.string().min(1) }))
  .output(
    z.object({
      state: z.string(),
      organizations: z.array(z.object({ id: z.string(), name: z.string() })),
    }),
  )

export const assignUnmatchedPatient = oc
  .route({ method: 'POST', path: '/v2/super/patients/{patientId}/assign-organization' })
  .input(z.object({ patientId: z.string().min(1), organizationId: z.string().min(1) }))
  .output(z.object({ organizationId: z.string() }))
